import { Injectable } from '@angular/core';
import { Config } from '@luggagehero/shared/environment';
import { Result } from '@luggagehero/shared/interfaces';
import { SharedHttpService } from '@luggagehero/shared/services/http';
import { TranslateService } from '@ngx-translate/core';

export enum ProductScope {
  'NA' = 'NA',
  'PerBag' = 'PerBag',
  'PerBooking' = 'PerBooking',
}

export interface ProductInfoWithContext {
  products: Array<ProductInfo>;
  storageLocationSpecificContext: boolean;
}

export interface ProductInfo {
  key: string;
  name: string;
  tags: { key: string; value: string }[];
  cost: number;
  value?: number;
  scope?: ProductScope;
  optional?: boolean;
}

export interface ProductPriceInput {
  productKey: string;
  valueCost: { value?: number; cost: number };
}

@Injectable()
export class ProductService {
  private apiEndPoint: string;

  constructor(
    private httpService: SharedHttpService,
    private translate: TranslateService,
  ) {
    this.apiEndPoint = `${Config.environment.STORAGE_MANAGER_API}`;
  }

  async getWalkInPricesForStorageLocation(
    storageLocationId: string,
    getDefaults = false,
  ): Promise<ProductInfoWithContext> {
    let url = `${this.apiEndPoint}/storage_locations/${storageLocationId}/products`;

    if (getDefaults) {
      url = `${url}?getDefaults=true`;
    }

    const res = await this.httpService.get<ProductInfoWithContext>(url, true);

    return res;
  }

  async setWalkInPricesForStorageLocation(
    storageLocationId: string,
    productPrices: ProductPriceInput[],
  ): Promise<ProductInfoWithContext> {
    const url = `${this.apiEndPoint}/storage_locations/${storageLocationId}/products`;

    const res = this.httpService.post<ProductInfoWithContext>(url, productPrices);
    return res;
  }

  async deletePricingContext(storageLocationId: string): Promise<Result> {
    const url = `${this.apiEndPoint}/storage_locations/${storageLocationId}/products`;
    return this.httpService.delete<Result>(url, true);
  }
}
